import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, LayoutDashboard, Globe, RefreshCw, Calendar, Disc3, ShieldCheck, Info } from 'lucide-react';

export default function Step6Success({ submissionResult, onNewRelease }) {
  const {
    releaseTitle = 'Your Release',
    releaseType = 'single',
    trackCount = 1,
    releaseDate = 'Upcoming',
    senritsuxRegistrationNumber = 'SX-2026-PENDING',
    referenceCode = '',
    submittedAt = new Date().toISOString(),
  } = submissionResult || {};

  const regNum = senritsuxRegistrationNumber || referenceCode || 'SX-2026-REGISTERED';

  return (
    <div className="dist-card dist-success-card">
      <div className="dist-success-icon-badge">
        <CheckCircle2 size={42} strokeWidth={2.5} />
      </div>

      <h2 className="dist-success-title">Release Submitted Successfully!</h2>
      <p style={{ fontSize: '1rem', color: 'rgba(255, 255, 255, 0.85)', maxWidth: '580px', margin: '0 auto 1.4rem', lineHeight: 1.6 }}>
        Your release <strong style={{ color: '#d9fb06' }}>&ldquo;{releaseTitle}&rdquo;</strong> has been successfully received by <span className="brand-font">SenritsuX</span>.
      </p>

      {/* SenritsuX Registration Number Display */}
      <div style={{ background: 'rgba(0, 0, 0, 0.35)', border: '1.5px solid rgba(217, 251, 6, 0.4)', borderRadius: '14px', padding: '1.2rem 1.5rem', maxWidth: '520px', margin: '0 auto 1.8rem', textAlign: 'center' }}>
        <div style={{ fontSize: '0.78rem', color: 'rgba(255, 255, 255, 0.65)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.3rem' }}>
          SenritsuX Registration Number
        </div>
        <div style={{ fontSize: '1.6rem', fontWeight: 800, color: '#d9fb06', letterSpacing: '0.06em', fontFamily: 'monospace' }}>
          {regNum}
        </div>
        <div style={{ fontSize: '0.78rem', color: 'rgba(255, 255, 255, 0.6)', marginTop: '0.4rem' }}>
          Keep this number for tracking your release and royalties with SenritsuX.
        </div>
      </div>

      {/* ISRC / UPC A&R Clarification Notice */}
      <div style={{ background: 'rgba(77, 74, 182, 0.3)', border: '1px solid rgba(255, 255, 255, 0.12)', borderRadius: '10px', padding: '0.9rem 1.2rem', maxWidth: '560px', margin: '0 auto 2rem', display: 'flex', alignItems: 'center', gap: '0.8rem', textAlign: 'left' }}>
        <Info size={20} color="#d9fb06" style={{ flexShrink: 0 }} />
        <span style={{ fontSize: '0.83rem', color: 'rgba(255, 255, 255, 0.85)', lineHeight: 1.45 }}>
          <strong>ISRC &amp; UPC Status:</strong> Official ISRC and UPC identifiers will be assigned and displayed on your Dashboard after A&amp;R metadata clarification.
        </span>
      </div>

      {/* Submission Metadata Highlights */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
          gap: '1rem',
          maxWidth: '650px',
          margin: '0 auto 2.5rem',
          background: 'rgba(0, 0, 0, 0.25)',
          padding: '1.2rem',
          borderRadius: '12px',
          border: '1px solid rgba(255, 255, 255, 0.08)',
        }}
      >
        <div style={{ textAlign: 'left' }}>
          <div style={{ fontSize: '0.75rem', color: 'rgba(255, 255, 255, 0.5)', textTransform: 'uppercase' }}>Format</div>
          <div style={{ fontSize: '0.92rem', fontWeight: 700, color: '#fff', display: 'flex', alignItems: 'center', gap: '0.3rem', marginTop: '0.2rem' }}>
            <Disc3 size={15} color="#d9fb06" /> {releaseType.toUpperCase()} ({trackCount} {trackCount === 1 ? 'Track' : 'Tracks'})
          </div>
        </div>

        <div style={{ textAlign: 'left' }}>
          <div style={{ fontSize: '0.75rem', color: 'rgba(255, 255, 255, 0.5)', textTransform: 'uppercase' }}>Target Release Date</div>
          <div style={{ fontSize: '0.92rem', fontWeight: 700, color: '#d9fb06', display: 'flex', alignItems: 'center', gap: '0.3rem', marginTop: '0.2rem' }}>
            <Calendar size={15} /> {releaseDate}
          </div>
        </div>

        <div style={{ textAlign: 'left' }}>
          <div style={{ fontSize: '0.75rem', color: 'rgba(255, 255, 255, 0.5)', textTransform: 'uppercase' }}>Status</div>
          <div style={{ fontSize: '0.92rem', fontWeight: 700, color: '#fff', display: 'flex', alignItems: 'center', gap: '0.3rem', marginTop: '0.2rem' }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#d9fb06' }} /> Submitted (A&amp;R Review)
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/dashboard" className="dist-btn-primary" style={{ textDecoration: 'none' }}>
          <LayoutDashboard size={18} /> Go to Dashboard
        </Link>

        <button
          type="button"
          className="dist-btn-secondary"
          onClick={onNewRelease}
        >
          <RefreshCw size={17} /> Submit Another Release
        </button>

        <Link to="/artist-web" className="dist-btn-secondary" style={{ textDecoration: 'none' }}>
          <Globe size={18} /> View Artist Web
        </Link>
      </div>
    </div>
  );
}
